import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    margin-top: 30px;
    padding: 16px 20px;
    border-radius: 12px;
    border: 1px solid #2838971a;
    background: ${theme.colors.gray.light};
  `}
`

export const TopRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`

export const Chips = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const FilledChip = styled(Box)`
  ${({ theme }) => css`
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.lightest};
    background: #28389799;
    border: 1px solid #283897;
  `}
`

export const OutlinedChip = styled(Box)`
  ${({ theme }) => css`
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.primary};
    background: none;
    border: 1px solid ${theme.colors.primary};
  `}
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    margin-top: 11px;
    font-size: 26px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const Subtitle = styled(Box)`
  ${({ theme }) => css`
    margin-top: 4px;
    font-size: 14px;
    color: ${theme.colors.gray[400]};
  `}
`
